import { createCrudSlice } from "./createCrudSlice";
import {
  GET_ACTIVE_BRANCHES,
  GET_DEVELOPER_BRANCH_DETAILS,
} from "helpers/url_helper";

const developerSettingsSlice = createCrudSlice({
  name: "developerSettings",
  urls: {
    getList: GET_ACTIVE_BRANCHES,
    getListMethod: "get",
    getDetails: GET_DEVELOPER_BRANCH_DETAILS,
  },
  initialFilters: {},
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } =
  developerSettingsSlice.actions;

// Export thunks
export const {
  getList: getActiveBranches,
  getDetails: getDeveloperBranchDetails,
} = developerSettingsSlice.thunks;

// Export reducer
export default developerSettingsSlice.reducer;
